import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export const sendTestEmail = async (): Promise<void> => {
    return baseAxios.post('/api/notifications/serviceProviders/mailIntegrations/test');
};

export default (axios: AxiosInstance = baseAxios): { sendTestEmail: () => Promise<void> } => ({
    sendTestEmail: async (): Promise<void> => {
        return axios.post('/api/notifications/serviceProviders/mailIntegrations/test');
    },
});
